import React from "react";
import {
  Box,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import { RecipeHeaderCard } from "./StyledComponents";

const RecipeHeader = ({ recipe, onEditClick }) => {
  const { t } = useTranslation();

  if (!recipe) {
    return null;
  }

  // Format the meal type with proper capitalization
  const formatMealType = (mealType) => {
    if (!mealType) return "Other";
    return mealType.charAt(0).toUpperCase() + mealType.slice(1);
  };

  return (
    <RecipeHeaderCard>
      <CardContent sx={{ p: 3 }}>
        {/* Title and Edit Button */}
        <Grid container spacing={3} alignItems="center">
          <Grid item xs>
            <Stack spacing={1}>
              <Typography variant="h4" fontWeight="bold">
                {recipe.name}
              </Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <RestaurantIcon color="primary" fontSize="small" />
                <Typography variant="body1" color="text.secondary">
                  {formatMealType(t(recipe.mealType || "other"))}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  • Serves {recipe.servings || 0}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
          <Grid item>
            <Tooltip title="Edit Recipe">
              <IconButton
                onClick={onEditClick}
                sx={{
                  color: "primary.main",
                  bgcolor: "primary.light + '0A'",
                  "&:hover": {
                    bgcolor: "primary.light",
                  },
                }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        {/* Nutrition Stats Grid */}
        <Grid container spacing={2}>
          <Grid item xs={6} sm={3} md>
            <Box
              sx={{
                p: 2,
                textAlign: "center",
                borderRadius: 2,
                bgcolor: "grey.50",
              }}
            >
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Calories
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {recipe.kCals || 0} kCal
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3} md>
            <Box
              sx={{
                p: 2,
                textAlign: "center",
                borderRadius: 2,
                bgcolor: "grey.50",
              }}
            >
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Protein
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {recipe.proteins || 0}g
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3} md>
            <Box
              sx={{
                p: 2,
                textAlign: "center",
                borderRadius: 2,
                bgcolor: "grey.50",
              }}
            >
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Carbs
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {recipe.carbs || 0}g
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3} md>
            <Box
              sx={{
                p: 2,
                textAlign: "center",
                borderRadius: 2,
                bgcolor: "grey.50",
              }}
            >
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Fats
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {recipe.fats || 0}g
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </RecipeHeaderCard>
  );
};

export default RecipeHeader;
